"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.useContextMenu = void 0;
const react_1 = require("react");
const components_1 = require("@veeam/components");
const useContextMenu = ({ items, }) => {
    const [contextMenuActive, setContextMenuActive] = react_1.useState(false);
    const [offsetPosition, setOffsetPosition] = react_1.useState({
        offsetX: 0,
        offsetY: 0,
    });
    const contextMenu = components_1.usePopover({
        isActive: !!items.length && contextMenuActive,
        config: [Object.assign({ xAxis: components_1.X_AXIS.insideLeft, yAxis: components_1.Y_AXIS.insideTop }, offsetPosition)],
        onOutsideClick: () => {
            if (contextMenuActive) {
                setContextMenuActive(false);
            }
        },
        render: (popoverRef) => react_1.createElement(components_1.Menu, { ref: popoverRef }, react_1.createElement(components_1.CommandMenu, {
            items: items.map((item) => (Object.assign(Object.assign({}, item), { onClick: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setContextMenuActive(false);
                    if (item.onClick && !item.disabled) {
                        item.onClick(e);
                    }
                } }))),
        })),
        target: {
            measure: () => document.body.getBoundingClientRect(),
        },
    });
    return [
        contextMenu,
        {
            show: (offsetPositionParams) => {
                if (offsetPositionParams) {
                    setOffsetPosition(offsetPositionParams);
                }
                setContextMenuActive(true);
            },
            hide: () => setContextMenuActive(false),
        },
    ];
};
exports.useContextMenu = useContextMenu;
//# sourceMappingURL=useContextMenu.js.map